var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechIconBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 165,
    viewBox: "0 0 153 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5386,
    cy: 84.1906,
    r: 61.7733,
    stroke: "#4E2575",
    strokeMiterlimit: 4.45214,
    strokeDasharray: "4 13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.812 84.0928C146.812 65.5936 138.745 48.9785 125.938 37.5727M22.2653 84.0928C22.2653 118.485 50.146 146.366 84.5386 146.366C99.2054 146.366 112.688 141.296 123.329 132.812",
    stroke: "#AF6DEE",
    strokeWidth: 3,
    strokeMiterlimit: 4.45214
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7454 150.957C86.573 156.269 106.691 152.423 122.582 142.014M102.402 17.8844C65.5395 8.00712 27.6746 29.7893 17.8283 66.5361C13.6293 82.2069 15.2039 98.0686 21.2503 111.874",
    stroke: "#7738B4",
    strokeWidth: 3,
    strokeMiterlimit: 4.45214
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechIconBg);
export default __webpack_public_path__ + "static/media/tech-icon-bg.3328f3f4b1011dc457e9a107687644e2.svg";
export { ForwardRef as ReactComponent };